import React from 'react';
import Attachment from './Attachment'
import block from 'bem-cn-lite';
import { I18n } from 'react-i18next'

class Attachments extends React.Component {
    render() {
        const b = block('Attachments');
        const {
            attachments
        } = this.props;
        return (
            <I18n>
            {
                (t) => (
                    <div className={b()}>
                        <div className={b('divider')}>
                            <div className={b('dividers-body')}>
                                <div className={b('divider-section', { left: true })}></div>
                                <div className={b('divider-section', { center: true })}>
                                    <span className={b('divider-content')}>{t('global:filesCount', { count: attachments.length })}</span>
                                </div>
                                <div className={b('divider-section', { right: true })}>
                                    <span className={b('divider-content')}>
                                        <img src="https://cdn.wrike.com/image/__cdnu/icon_grey_vector_collaboration_clip.svg" alt="Clip" className={b('divider-icon')}/>
                                        <img src="https://cdn.wrike.com/image/__cdnu/icon_grey_vector_collaboration_burger.svg" alt="Menu" className={b('divider-icon')}/>
                                    </span>
                                </div>
                            </div>
        
                        </div>
        
                        <div className={b('list')}>
                            {
                                attachments.map((attachment, index) => {
                                    return <Attachment {...attachment} key={index}/>
                                })
                            }
                        </div>
        
                    </div> 
                )
            }
            </I18n>

        )
    }
}

export default Attachments